module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan2-1-24777958e7660d48ff114ef952cbad00.webp";